import { createAuthClient } from "./client";
import { createMockAuthClient } from "./mock";
import type { AuthClient } from "./types";

export { createAuthClient, TokenError, type AuthConfig } from "./client";
export { createMockAuthClient } from "./mock";
export { decodeJwtPayload, pkceChallenge, randomToken } from "./pkce";
export type { AuthClient, AuthStatus, Claims, Session } from "./types";

/** Builds a client from the app's public environment; falls back to the mock when the pool is not configured. */
export async function authClientFromEnv(env: Record<string, string | undefined>, origin: string, options: { scopes?: string[] } = {}): Promise<AuthClient> {
  const authority = env.AUTH_AUTHORITY;
  const clientId = env.AUTH_CLIENT_ID;
  if (!authority || !clientId || env.AUTH_MOCK === "1") {
    if (typeof console !== "undefined") console.warn("[auth] using the mock auth client; set AUTH_AUTHORITY and AUTH_CLIENT_ID to use Cognito");
    return createMockAuthClient();
  }
  return createAuthClient({ authority, clientId, redirectUri: `${origin}/auth/callback`, postLogoutRedirectUri: `${origin}/auth/signed-out`, scopes: options.scopes });
}
